export const SUCCESS_FEEDBACK_MESSAGES = {
  DELETION_SUCCESS: 'success_feedback_messages.deletion_success',
  UPDATE_SUCCESS: 'success_feedback_messages.update_success',
  CREATION_SUCCESS: 'success_feedback_messages.creation_success',
  ADD_SUCCESS: 'success_feedback_messages.add_success',
};
